<template>
  <div class="yh-page">
    <el-card v-loading="loading">
      
      <el-row slot="header" type="flex" justify="start" align="middle" class="p-3" :gutter="10">
        <el-col :span="10">
          <el-input placeholder="输入船舶名称进行搜索..." v-model.trim="query.search"
                    @keyup.enter.native="handleSearch">
            <el-button slot="append" icon="el-icon-search" :loading="searching" @click="handleSearch">搜索</el-button>
          </el-input>
        </el-col>
        <el-col :span="3">
          <el-select placeholder="请选择签署状态" v-model="query.status" filterable clearable @change="handleSearch">
            <el-option v-for="s in status_list" :key="s.value"
                      :label="s.name" :value="s.value"></el-option>
          </el-select>
        </el-col>          
        <el-col :span="6">
          <el-select placeholder="请选择业务部门" v-model="query.business_area" filterable clearable @change="handleSearch">
            <el-option v-for="g in groupList" :key="g.id" :value="g.name"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-button type="primary" size="small" icon="el-icon-s-claim" @click="showBatchSendDialog">批量签署
          </el-button>
        </el-col>
      </el-row>
     
      <file-sign-list :attachments="list" object_type="receipt.receipt" @checkFiles="handleCheckFiles"></file-sign-list>
    </el-card>

    <pagination ref="pagination" :size.sync="query.limit" :offset.sync="query.offset" :total="total" @updateList="getList"></pagination>
    <signer-selection-dialog ref="signerSelectionDialog"
      :attachments="policy_table_file_list"
      :object_type="'receipt.receipt'"
      :send_type="'multiple'"
      @cancel="handleCancelSend"
      @confirm="handleSignConfirm"
    ></signer-selection-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import FileSignList from '@/components/FileSignList'
import { getTypeFileList } from '@/api/common'
import { fetchList as fetchGroupList } from "@/api/group";
import SignerSelectionDialog from '@/components/SignerSelectionDialog'
import { fetchReceiptPolicyTableFileList } from "@/api/receipt"

export default {
  name: "receipt-list",
  components: {
    Pagination,
    FileSignList,
    SignerSelectionDialog,
  },
  data(){
    return {
      query:{
        file_type: 'policy_recovery_receipt',
        search: '',
        limit: 10,
        offset: 0,
        status: '',
      },
      loadingText: '正在加载数据，请稍等...',
      loading: false,
      searching: false,
      groupList:[],
      total: 0,
      list:[],
      status_list: [
        {value: '-1', name: '未发送'},
        {value: '0', name: '未签署'},
        {value: '1', name: '签署中'},
        {value: '2', name: '已签署'},
      ],
      checkList: [],
      policy_table_file_list: [],
    }
  },
  methods: {
    handleSearch() {
      this.$refs.pagination.backNumOne()
    },
    loadData() {
    
        this.loading = true
        let p = []
        p.push(fetchGroupList())

        Promise.all(p)
        .then(res => {
          this.groupList = res[0]
        })
        .catch(err => {
          this.loading = false
          this.$error_message(err)
        })
    },
    getList() {
      this.loading = true
      getTypeFileList(this.query)
      .then(res => {
        // console.log(res)
        this.loading = false
        this.list = res.results
        this.total = res.count
      }).catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    handleCancelSend() {
      this.policy_table_file_list = []
      console.log('handleCancelSend')
    },
    handleSignConfirm(data) {
      console.log('handleSignConfirm', data)
      this.policy_table_file_list = []
      this.getList()
    },
    handleCheckFiles(files) {
      // console.log('Selected files:', files)
      this.checkList = files
    },
    showBatchSendDialog() {
      this.policy_table_file_list = []
      let p = []
      for (let i = 0; i < this.checkList.length; i++) {
        p.push(fetchReceiptPolicyTableFileList(this.checkList[i].file_relation.object_id))
      }

      Promise.all(p)
      .then(res => {
        for (let i = 0; i < res.length; i++) {
          this.policy_table_file_list.push(...res[i])
        }

        this.$refs.signerSelectionDialog.showDialog(this.checkList)
      })
      .catch(err => {
        console.log(err)
      })
    },
  },
  created() {
    this.getList()
    this.loadData()
  }
}
</script>